/** Phase 3B.1.1 — Maps a Reporting Agent's `recommended_actions` text to a
 *  concrete UI target. Best-effort regex; gracefully falls back to a
 *  non-navigating checkbox when no target is identified. Patterns are
 *  documented inline so future prompt tuning can target them directly.
 */
export const ACTION_PATTERNS = [
  // German + English approvals
  { key: "approvals", re: /(approval|freigabe|ausstehend|pending)/i,
    label_de: "Freigaben öffnen", label_en: "Open approvals", to: "/app/approvals" },
  // Permission denials / security
  { key: "security", re: /(permission[- ]?denial|berechtigung|denied|security)/i,
    label_de: "Sicherheit prüfen", label_en: "Open security activity", to: "/app/dashboard#security" },
  // Campaigns
  { key: "campaign", re: /(campaign|kampagne)/i,
    label_de: "Kampagnen öffnen", label_en: "Open campaigns", to: "/app/campaigns" },
  // Budget
  { key: "budget", re: /(budget|spend|kosten)/i,
    label_de: "Budget prüfen", label_en: "Review budget", to: "/app/campaigns" },
];

/** Returns {target} or null if no pattern matches. */
export function routeReportAction(actionText, locale = "de") {
  if (!actionText || typeof actionText !== "string") return null;
  for (const p of ACTION_PATTERNS) {
    if (p.re.test(actionText)) {
      return { key: p.key, label: locale === "en" ? p.label_en : p.label_de, to: p.to };
    }
  }
  return null;
}
